import articlesDashboard from "./articlesDashboard"
export default articlesDashboard;
